export class ListTableMaintenanceRunsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListTableMaintenanceRunsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortMaintenanceRunBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListTableMaintenanceRunsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
